import { ExpiryModal } from '@zopauk/react-components';
import type { ExpiryModalProps } from '@zopauk/nextjs-auth';

// Temporary: replace with SessionExpiryModal from @zopauk/web-ui when this app moves to Tailwind
export const SessionExpiryModal = ({ onKeepSession, onEndSession, isOpen }: ExpiryModalProps) => (
  <ExpiryModal
    data-automation="ZA.expiry-modal"
    onKeepSession={onKeepSession}
    onEndSession={onEndSession}
    isOpen={isOpen}
  />
);
